module.exports = __webpack_public_path__ + "static/media/logo-pudo-alt.9df98a0d.png";